module.exports = __webpack_public_path__ + "img/fork-lane.77c1dfdf.png";